import { render } from "./placed.vue?vue&type=template&id=600a491c"
import script from "./placed.vue?vue&type=script&lang=js"
export * from "./placed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__